const DEFAULT_TIMEZONE = 'Europe/Amsterdam';

export const getClientTimezone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone ?? DEFAULT_TIMEZONE;
    } catch (e) {
        return DEFAULT_TIMEZONE;
    }
};